import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import SafeIcon from '../common/SafeIcon';
import { MOOD_TYPES } from '../data/mockData';

const TimelineEntry = ({ entry }) => {
  const moodConfig = MOOD_TYPES.find(m => m.id === entry.mood) || MOOD_TYPES[2];
  
  return (
    <div className="relative pl-8 pb-8 group">
      {/* Timeline Line */}
      <div className="absolute left-[11px] top-8 bottom-0 w-[2px] bg-ink-700 group-last:bg-transparent" />
      
      {/* Timeline Node */}
      <div className={`absolute left-0 top-1 w-6 h-6 rounded-full border-4 border-ink-900 ${moodConfig.bgColor} flex items-center justify-center`}>
        <div className={`w-2 h-2 rounded-full ${moodConfig.color.replace('text-', 'bg-')}`} />
      </div>

      {/* Content Card */}
      <div className="glass-panel rounded-xl p-5 hover:border-ink-500 transition-colors">
        <div className="flex justify-between items-start mb-2">
          <div className="flex items-center gap-2">
            <span className={`text-xs font-semibold px-2 py-1 rounded-md ${moodConfig.bgColor} ${moodConfig.color}`}>
              {moodConfig.label}
            </span>
            <span className="text-xs text-gray-500">
              {formatDistanceToNow(new Date(entry.date), { addSuffix: true })}
            </span>
          </div>
          <button className="text-gray-600 hover:text-gray-300">
            <SafeIcon name="MoreHorizontal" className="w-4 h-4" />
          </button>
        </div>
        
        <p className="text-gray-300 text-sm leading-relaxed mb-3">
          {entry.content}
        </p>

        {entry.tags && entry.tags.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {entry.tags.map(tag => (
              <span key={tag} className="text-xs text-lilac-light bg-lilac/10 px-2 py-1 rounded-md border border-lilac/20">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Timeline = ({ entries }) => {
  return (
    <div className="mt-8">
      <h3 className="text-sm font-semibold text-gray-400 mb-6 uppercase tracking-wider">Recent Signals</h3>
      <div className="relative">
        {entries.map(entry => (
          <TimelineEntry key={entry.id} entry={entry} />
        ))}
      </div>
    </div>
  );
};

export default Timeline;